import { graphql } from 'react-relay';
import serverVars from 'server-vars';
import commitMutation from 'relay-commit-mutation-promise';
import { getAuthHash } from '../authHelpers.es';

const mutation = graphql`
    mutation registrationMutation($input: UserRegistrationInput!) {
        userRegistration(input: $input) {
            emailToken
            user {
                serviceId
                userId: serviceId # for backwards compatibility with old versions
                createdDate
                isVerifiedTrade
                verifiedTradeStatus
                profile {
                    email
                    firstName
                    lastName
                    currency
                    measurementUnit
                }
                ...userTradeStatus_user
            }
            userToken
            userId
            isNewUser
        }
    }
`;

export function registrationMutation(environment, args) {
    const { email, password, marketingOptIn } = args;
    // Requires auth hash to prevent bots hitting graphQL directly and making fake auths.
    const authHash = getAuthHash({ email });
    const cookieDomain = serverVars.get('cookieDomain'); // for setting response cookies
    return commitMutation(environment, {
        mutation,
        variables: {
            input: { email, password, marketingOptIn, authHash, cookieDomain },
        },
    });
}
